// extracted by mini-css-extract-plugin
export default {"Widget":"Widget_Widget__bRZqg","OuterWidget":"Widget_OuterWidget__WRLSl","InnerWidget":"Widget_InnerWidget__NsORP","Label":"Widget_Label__ReE34","Logo":"Widget_Logo__hfCwW"};